export default function (owner, key, value) {
	if (value === undefined) {
		return owner.__data ? owner.__data[key] : null;
	} else {
		owner.__data = owner.__data || {};
		owner.__data[key] = value;
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/inputmask/lib/dependencyLibs/data.js
// module id = null
// module chunks = 